import { host } from "./config";
import 'whatwg-fetch'

const serverURL = `${host}/`;

const fetch = window.fetch;
export const post = (service, body, next) => {
    let options = {};
    if (body)
        options.body = JSON.stringify(body);
    options.headers = { ...options.headers, "Authorization": "Bearer " + localStorage.getItem('token'), "Content-Type": "application/json" };
    options.method = 'POST';
    fetch(service, options)
        .then(
            (res) => {
                res.json().then(res => {
                    if (res.error) {
                        if (res.error.name == "ValidationError") {
                            next(res.error.details.messages)
                        } else {
                            next(res.error)
                        }
                    } else
                        next(null, res)
                }, (err) => next(err))
            },
            (err) => next(err)
        )
}

export let currentuser = {
    token: localStorage.getItem("token"),
    id: localStorage.getItem("userid"),
    name: localStorage.getItem("username"),
    role: localStorage.getItem("role"),
    profile: localStorage.getItem("profile")
}
export const patch = (service, body, next) => {
    let options = {};
    if (body)
        options.body = JSON.stringify(body);
    options.headers = { ...options.headers, "Authorization": "Bearer " + localStorage.getItem('token'), "Content-Type": "application/json" };
    options.method = 'PUT';
    fetch(serverURL + service, options)
        .then(
            (res) => {
                res.json().then(res => {
                    if (res.error) {
                        if (res.error.name == "ValidationError") {
                            next(res.error.details.messages)
                        } else {
                            next(res.error)
                        }
                    } else
                        next(null, res)
                }, (err) => next(err))
            },
            (err) => next(err)
        )
}

export const del = (service, next) => {
    let options = {};
    service = service
    options.headers = { ...options.headers, "Authorization": "Bearer " + localStorage.getItem('token'), "Content-Type": "application/json" };
    options.method = 'DELETE';
    fetch(serverURL + service, options)
        .then(
            (res) => {
                res.json().then(res => {
                    if (res.error) {
                        if (res.error.name == "ValidationError") {
                            next(res.error.details.messages)
                        } else {
                            next(res.error)
                        }
                    } else
                        next(null, res)
                }, (err) => next(err))
            },
            (err) => next(err)
        )
}

export const get = (service, next) => {
    let options = {};
    service = service
    options.headers = { ...options.headers, "Authorization": "Bearer " + localStorage.getItem('token'), "Content-Type": "application/json" };
    options.method = 'GET';
    fetch(serverURL + service, options)
        .then(
            (res) => {
                res.json().then(res => {
                    if (res.error) {
                        if (res.error.name == "ValidationError") {
                            next(res.error.details.messages)
                        } else {
                            next(res.error)
                        }
                    } else
                        next(null, res)
                }, (err) => next(err))
            },
            (err) => next(err)
        )
}
export const getAsync = async (service, next) => {
    let options = { ...auth() };
    options.headers = { ...options.headers, "Authorization": "Bearer " + localStorage.getItem('token'), "Content-Type": "application/json" };
    options.method = 'GET';
    let result = await fetch(serverURL + service, options)
    return await result.json();
}